export const WEAPONS = [
  { name: 'ひのきのぼう', value: 2 },
  { name: 'こんぼう', value: 8 },
  { name: 'どうのつるぎ', value: 10 },
  { name: 'せいなるナイフ', value: 12 },
  { name: 'くさりがま', value: 15 },
  { name: 'てつのやり', value: 20 },
  { name: 'まどうしのつえ', value: 27 },
  { name: 'はがねのつるぎ', value: 30 },
  { name: 'おおかなづち', value: 40 },
  { name: 'ロトのつるぎ', value: 40 },
  { name: 'いかずちのつえ', value: 45 },
  { name: 'ドラゴンキラー', value: 55 },
  { name: 'ひかりのつるぎ', value: 70 },
  { name: 'いなずまのけん', value: 95 },
  { name: 'はかいのつるぎ', value: 105 }
]
